<template>
  <div
    class="background"
    :style="{ 'border-radius': isSimulation ? borderRadius : 0 }"
  >
    <v-carousel
      continuous
      :cycle="!isSimulation"
      hide-delimiters
      :show-arrows="false"
      height="100%"
      :style="{    
        'border-radius': isSimulation ? borderRadius : 0,
        'height': isMenu ? 'calc(90vh)' : '100%'
      }"
    >
      <v-carousel-item
        v-for="(item,i) in Carousel"
        :key="i"
        :src="item"
        style="height: 100%;"
      />
    </v-carousel>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import constants from '@/constants'
  export default {
    name: 'Background',
    data () {
      return {
      }
    },
    computed: {
      ...mapState('app',['Carousel']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      }
    }
  }
</script>
<style scoped>
  .background {
    padding-left: 360px;
    position: fixed;
    top:0px;
    width: 100%;
    right: 0px;
    height: calc(100vh);
  }
</style>
